import { CloudActions, AdminUrls } from '@portal/portal-core';

import { sendAction } from 'api';
import type { WrappedHttpResult } from 'api';
import { AuthClientUtils } from 'ducks/auth-client';
import { serverUrl } from '@/Config';

const emailLookup = async (value: string): Promise<WrappedHttpResult> => {
  const url = AdminUrls.adminClientUrl(serverUrl);
  const action = CloudActions.adminFindUsersByPrimaryEmails(value);
  const authToken = AuthClientUtils.getAuthToken();
  if (value.length < 3) return { succeeded: true, data: {} }; // returns 404 if < 3 chars submitted
  return sendAction({ url, action, authToken });
};

export default emailLookup;
